import { ApplicationState } from '@/store';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { CalculatedTableColumn } from '../types';
import deepEqual from 'fast-deep-equal/es6/react';

export function useColumnWidth(columns: CalculatedTableColumn[], gridRef: React.RefObject<HTMLDivElement>) {
  const [gridColumnsWidth, setGridColumnsWidth] = useState('');

  const scrollRowIndex = useSelector(({ ui }: ApplicationState) => ui.uniDashRowScrollIndex || 0, deepEqual);
  const activeTab = useSelector(({ offersDashboard }: ApplicationState) => offersDashboard.currentTab);

  useEffect(() => {
    let width = '';
    for (const column of columns) {
      width = column.width ? `${width} ${column.width}` : 'minmax(136px, 1.25fr)';
    }
    setGridColumnsWidth(width);
  }, [columns]);

  useEffect(() => {
    if (scrollRowIndex && gridRef?.current) {
      gridRef.current.scrollTo(0, scrollRowIndex);
    }
  }, [gridRef?.current]);

  useEffect(() => {
    if (gridRef?.current) {
      gridRef.current.scrollTo(0, 0);
    }
  }, [activeTab]);

  return gridColumnsWidth;
}
